module.exports = __webpack_public_path__ + "efd274076981c2fca1c76ca7e2620dca.jpg";